export default "__VITE_ASSET__15TRsU$h__"